

















































































import { Component, Vue, Prop } from "vue-property-decorator";
import { FormBuilderField } from "../types/FormBuilderTypes";
import { ComponentsTypes } from "@/components/DinamicallyForm/TipoComponentes";

@Component
export default class CanvasField extends Vue {
  @Prop({ required: true }) field!: FormBuilderField;
  @Prop({ default: false }) isSelected!: boolean;

  public get componentTypeName(): string {
    const typeNames: Record<ComponentsTypes, string> = {
      [ComponentsTypes.TextBox]: "Texto",
      [ComponentsTypes.MultiCombo]: "Multi Select",
      [ComponentsTypes.SingleCombo]: "Select",
      [ComponentsTypes.Date]: "Fecha",
      [ComponentsTypes.TextArea]: "Área Texto",
      [ComponentsTypes.Switch]: "Switch",
      [ComponentsTypes.RadioButton]: "Radio",
      [ComponentsTypes.TablaCodigoDescripcion]: "Cod-Desc",
      [ComponentsTypes.DateTime]: "Fecha/Hora",
      [ComponentsTypes.Slot]: "Custom",
    };
    return typeNames[this.field.componentType] || "Desconocido";
  }

  public get componentIcon(): string {
    const icons: Record<ComponentsTypes, string> = {
      [ComponentsTypes.TextBox]: "mdi-form-textbox",
      [ComponentsTypes.MultiCombo]: "mdi-form-select",
      [ComponentsTypes.SingleCombo]: "mdi-form-dropdown",
      [ComponentsTypes.Date]: "mdi-calendar",
      [ComponentsTypes.TextArea]: "mdi-text-box-outline",
      [ComponentsTypes.Switch]: "mdi-toggle-switch",
      [ComponentsTypes.RadioButton]: "mdi-radiobox-marked",
      [ComponentsTypes.TablaCodigoDescripcion]: "mdi-table-search",
      [ComponentsTypes.DateTime]: "mdi-calendar-clock",
      [ComponentsTypes.Slot]: "mdi-puzzle",
    };
    return icons[this.field.componentType] || "mdi-help-circle";
  }

  public get componentColor(): string {
    return this.isSelected ? "primary" : "grey";
  }
}
